export default __webpack_public_path__ + "static/media/home1.e9c317f6.png";